module.exports = __webpack_public_path__ + "static/media/ecos_Raum_28_3P.c3d6f80c.jpg";